import { render, staticRenderFns } from "./PossibleInvestment.vue?vue&type=template&id=5d0d5bf7&scoped=true&"
import script from "./PossibleInvestment.vue?vue&type=script&lang=js&"
export * from "./PossibleInvestment.vue?vue&type=script&lang=js&"
import style0 from "./PossibleInvestment.vue?vue&type=style&index=0&id=5d0d5bf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d5bf7",
  null
  
)

export default component.exports